<template>
  <div class="custom-modal" v-if="showModal">
    <el-dialog
      :class="{'modal-content-no-padding': modalContentNoPadding, 'vertical-center-modal': isVerticalCenter}"
      :visible.sync="showModal"
      append-to-body
      :show-close="showClose"
      :before-close="beforeCloseHandle"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template #header>
        <slot name="header"></slot>
      </template>
      <slot></slot>
      <template #footer>
        <slot name="footer">
          <el-button
            v-if="showCancelBtn"
            :type="cancelBtnType"
            @click.native="cancelHandle($event)"
          >
            {{ cancelBtnText }}
          </el-button>
          <el-button
            v-if="showSubmitBtn"
            :type="submitBtnType"
            @click.native="submitHandle($event)"
          >
            {{ submitBtnText }}
          </el-button>
        </slot>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CustomModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showCancelBtn: {
      type: Boolean,
      default: true
    },
    showSubmitBtn: {
      type: Boolean,
      default: true
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    },
    submitBtnText: {
      type: String,
      default: '确认'
    },
    cancelBtnType: {
      type: String,
      default: 'default'
    },
    submitBtnType: {
      type: String,
      default: 'primary'
    },
    modalContentNoPadding: {
      type: Boolean,
      default: false
    },
    // 是否显示右上角关闭图标
    showClose: {
      type: Boolean,
      default: true
    },
    // 弹窗是否垂直居中
    verticalCenter: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    showModal: {
      get(){
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    // 外部显式传入 top 时，优先按 top 定位，不启用垂直居中
    isVerticalCenter() {
      return this.verticalCenter && !this.$attrs.top
    }
  },
  methods: {
    submitHandle(event) {
      this.$emit('submitHandle', event)
    },
    cancelHandle(event) {
      this.$emit('cancelHandle', event)
    },
    // 点击右上角关闭图标时，与取消按钮保持一致的关闭逻辑
    beforeCloseHandle() {
      this.$emit('cancelHandle')
    }
  }
}
</script>

<style lang="less" scoped>
.modal-content-no-padding /deep/ .el-dialog__body {
  padding: 0;
}

// 底部按钮区域上边框分割线
.el-dialog__wrapper /deep/ .el-dialog__footer {
  border-top: 1px solid #EBEAEE;
  padding: 12px 20px;
}

// 垂直居中：弹窗高度超出视口时 margin: auto 会自动退化为可滚动布局
.vertical-center-modal {
  display: flex;

  /deep/ .el-dialog {
    margin: auto !important;
  }
}
</style>
